import { columnDef_aggregationFn_Z71F7D04B, columnDef_aggregatedCell_Z1DDB00E5, columnDef_header_Z5FD1F5D2, columnDef_id_Z721C83C5, columnDef_cell_Z1DDB00E5, columnDef_accessorKey_Z721C83C5, columnDef_columns_Z2906D979, columnDef_header_Z721C83C5 } from "../../Feliz.TanStack.Table/ColumnDef.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library.3.7.1/List.js";
import { createElement } from "react";
import { int32ToString, equals, createObj, round } from "../fable_modules/fable-library.3.7.1/Util.js";
import { Aggregation } from "../../Feliz.TanStack.Table/Types.fs.js";
import { Record, Union } from "../fable_modules/fable-library.3.7.1/Types.js";
import { record_type, class_type, union_type, int32_type } from "../fable_modules/fable-library.3.7.1/Reflection.js";
import { MakeData_make, Types_Person$reflection } from "../MakeData.fs.js";
import { Table_getRowModel_Z4395D14A, Table_getVisibleCells_773C3262, Table_getContext_Z78EF7AD2, Table_getHeaderGroups_Z4395D14A, Table_getContext_315F98D7, Html_flexRender_Z6DEE00B4, Table_init_Z5C3B000E } from "../../Feliz.TanStack.Table/Table.fs.js";
import { tableProps_paginationRowModel, tableProps_groupedRowModel, tableProps_filteredRowModel, tableProps_expandedRowModel, tableProps_columns_Z2906D979 } from "../../Feliz.TanStack.Table/TableProps.fs.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { Table_hasNextPage_Z4395D14A, Table_hasPreviousPage_Z4395D14A, Table_setPageSize, Table_getPageCount_Z4395D14A, Table_setPageIndex, Table_nextPage_Z4395D14A, Table_previousPage_Z4395D14A } from "../../Feliz.TanStack.Table/Pagination.fs.js";
import { Row_toggleExpanded_773C3262 } from "../../Feliz.TanStack.Table/Expanding.fs.js";
import { Cell_getIsPlaceholder_Z78EF7AD2, Cell_getIsAggregated_Z78EF7AD2, Cell_getIsGrouped_Z78EF7AD2, Column_getGroupedIndex_Z2685F962, Column_getIsGrouped_Z2685F962, Column_getCanGroup_Z2685F962, Column_toggleGrouping_Z2685F962 } from "../../Feliz.TanStack.Table/Grouping.fs.js";
import { empty, append, singleton, map, delay, toList } from "../fable_modules/fable-library.3.7.1/Seq.js";
import { join } from "../fable_modules/fable-library.3.7.1/String.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.67.0/Interop.fs.js";
import { Row_getIsExpanded_773C3262 } from "../../Feliz.TanStack.Table/Row.fs.js";
import { FSharpMap__get_Item, ofList } from "../fable_modules/fable-library.3.7.1/Map.js";
import { rangeDouble } from "../fable_modules/fable-library.3.7.1/Range.js";
import { Table_getState_Z4395D14A } from "../../Feliz.TanStack.Table/TableState.fs.js";
import { useFeliz_React__React_useElmish_Static_B42E862 } from "../fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";

export const defaultColumns = ofArray([ofArray([columnDef_header_Z721C83C5("Name"), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Firstname"), columnDef_header_Z721C83C5("First Name"), columnDef_cell_Z1DDB00E5((info) => info.getValue())]), ofArray([columnDef_accessorKey_Z721C83C5("Lastname"), columnDef_id_Z721C83C5("Lastname"), columnDef_cell_Z1DDB00E5((info_1) => info_1.getValue()), columnDef_header_Z5FD1F5D2((_arg1) => createElement("span", {
    children: "Last Name",
}))])]))]), ofArray([columnDef_header_Z721C83C5("info"), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Age"), columnDef_header_Z5FD1F5D2((_arg2) => "Age"), columnDef_aggregatedCell_Z1DDB00E5((props_1) => round((props_1.getValue() * 100) / 100)), columnDef_aggregationFn_Z71F7D04B(new Aggregation(5))]), ofArray([columnDef_header_Z721C83C5("More Info"), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Visits"), columnDef_header_Z5FD1F5D2((_arg3) => createElement("span", {
    children: "Visits",
})), columnDef_aggregationFn_Z71F7D04B(new Aggregation(0))]), ofArray([columnDef_accessorKey_Z721C83C5("Status"), columnDef_header_Z721C83C5("Status")]), ofArray([columnDef_accessorKey_Z721C83C5("Progress"), columnDef_header_Z721C83C5("Profile Progress"), columnDef_cell_Z1DDB00E5((props_3) => (`${round((props_3.getValue() * 100) / 100)}%`)), columnDef_aggregationFn_Z71F7D04B(new Aggregation(4)), columnDef_aggregatedCell_Z1DDB00E5((props_4) => (`${round((props_4.getValue() * 100) / 100)}%`))])]))])]))])]);

export class PaginateChange extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["First", "Previous", "Next", "Last", "Index"];
    }
}

export function PaginateChange$reflection() {
    return union_type("Examples.Grouping.PaginateChange", [], PaginateChange, () => [[], [], [], [], [["Item", int32_type]]]);
}

export class State extends Record {
    constructor(Table) {
        super();
        this.Table = Table;
    }
}

export function State$reflection() {
    return record_type("Examples.Grouping.State", [], State, () => [["Table", class_type("Feliz.TanStack.Table.Types.Table`1", [Types_Person$reflection()])]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ColumnClicked", "Paginate", "PageSizeChange", "ExpandClicked"];
    }
}

export function Msg$reflection() {
    return union_type("Examples.Grouping.Msg", [], Msg, () => [[["Item", class_type("Feliz.TanStack.Table.Types.Column`1", [Types_Person$reflection()])]], [["Item", PaginateChange$reflection()]], [["Item", int32_type]], [["Item", class_type("Feliz.TanStack.Table.Types.Row`1", [Types_Person$reflection()])]]]);
}

export function init() {
    return [new State(Table_init_Z5C3B000E(ofArray([["data", MakeData_make(10000)], tableProps_columns_Z2906D979(defaultColumns), tableProps_expandedRowModel(), tableProps_filteredRowModel(), tableProps_groupedRowModel(), tableProps_paginationRowModel()]))), Cmd_none()];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const paginateChange = msg.fields[0];
            return [new State((paginateChange.tag === 1) ? Table_previousPage_Z4395D14A(state.Table) : ((paginateChange.tag === 2) ? Table_nextPage_Z4395D14A(state.Table) : ((paginateChange.tag === 3) ? Table_setPageIndex(Table_getPageCount_Z4395D14A(state.Table) - 1, state.Table) : ((paginateChange.tag === 4) ? Table_setPageIndex(paginateChange.fields[0] - 1, state.Table) : Table_setPageIndex(0, state.Table))))), Cmd_none()];
        }
        case 2: {
            return [new State(Table_setPageSize(msg.fields[0], state.Table)), Cmd_none()];
        }
        case 3: {
            Row_toggleExpanded_773C3262(msg.fields[0]);
            return [new State(state.Table), Cmd_none()];
        }
        default: {
            Column_toggleGrouping_Z2685F962(msg.fields[0]);
            return [new State(state.Table), Cmd_none()];
        }
    }
}

export function view(state, dispatch) {
    let elems_8, children_8, properties_9, elems_7, elems_6, elems_10;
    let thead;
    const children_2 = toList(delay(() => map((headerGroup) => {
        let elems_2;
        return createElement("tr", createObj(ofArray([["key", headerGroup.id], (elems_2 = toList(delay(() => map((header) => {
            let elems_1;
            return createElement("th", createObj(ofArray([["key", header.id], ["colSpan", header.colSpan], (elems_1 = toList(delay(() => {
                let children;
                return header.isPlaceholder ? singleton(null) : singleton((children = toList(delay(() => {
                    let elems;
                    return append(Column_getCanGroup_Z2685F962(header.column) ? singleton(createElement("button", createObj(ofArray([["className", join(" ", ["ghost-button"])], ["style", {
                        cursor: "pointer",
                    }], ["onClick", (_arg1) => {
                        dispatch(new Msg(0, header.column));
                    }], (elems = [Column_getIsGrouped_Z2685F962(header.column) ? (`🛑 ${Column_getGroupedIndex_Z2685F962(header.column)}`) : "👊 "], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => singleton(Html_flexRender_Z6DEE00B4(header.column.columnDef.header, Table_getContext_315F98D7(header)))));
                })), createElement("div", {
                    children: Interop_reactApi.Children.toArray(Array.from(children)),
                })));
            })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
        }, headerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
    }, Table_getHeaderGroups_Z4395D14A(state.Table))));
    thead = createElement("thead", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    });
    let tbody;
    const children_6 = toList(delay(() => map((row) => {
        let elems_5;
        return createElement("tr", createObj(ofArray([["key", row.id], (elems_5 = toList(delay(() => map((cell) => {
            let properties_4, elems_4;
            return createElement("td", createObj(ofArray([(properties_4 = singleton_1(["backgroundColor", Cell_getIsGrouped_Z78EF7AD2(cell) ? "#0aff0082" : (Cell_getIsAggregated_Z78EF7AD2(cell) ? "#ffa50078" : (Cell_getIsPlaceholder_Z78EF7AD2(cell) ? "#ff000042" : "white"))]), ["style", createObj(properties_4)]), (elems_4 = toList(delay(() => {
                let children_4, elems_3;
                return Cell_getIsGrouped_Z78EF7AD2(cell) ? singleton((children_4 = singleton_1(createElement("button", createObj(ofArray([["className", join(" ", ["ghost-button"])], ["onClick", (_arg2) => {
                    dispatch(new Msg(3, row));
                }], (elems_3 = [Html_flexRender_Z6DEE00B4(cell.column.columnDef.cell, Table_getContext_Z78EF7AD2(cell)), Row_getIsExpanded_773C3262(row) ? "👇" : "👉", ` ${row.subRows.length}`], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))), createElement("span", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_4)),
                }))) : (Cell_getIsAggregated_Z78EF7AD2(cell) ? singleton(Html_flexRender_Z6DEE00B4((!equals(cell.column.columnDef.aggregatedCell, null)) ? cell.column.columnDef.aggregatedCell : cell.column.columnDef.cell, Table_getContext_Z78EF7AD2(cell))) : (Cell_getIsPlaceholder_Z78EF7AD2(cell) ? singleton(null) : singleton(Html_flexRender_Z6DEE00B4(cell.column.columnDef.cell, Table_getContext_Z78EF7AD2(cell)))));
            })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
        }, Table_getVisibleCells_773C3262(row)))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])));
    }, Table_getRowModel_Z4395D14A(state.Table).rows)));
    tbody = createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_6)),
    });
    let paginationControls;
    const selectOptions = ofList(toList(delay(() => map((i) => [int32ToString(i), [`Show ${i}`, () => {
        dispatch(new Msg(2, i));
    }]], rangeDouble(10, 10, 50)))));
    const pageControl = (text, isDisabled, onClick) => createElement("button", {
        className: join(" ", ["button"]),
        children: text,
        disabled: isDisabled,
        onClick: onClick,
    });
    paginationControls = createElement("div", createObj(ofArray([["className", join(" ", ["is-inline-block"])], (elems_8 = [pageControl("\u003c\u003c", !Table_hasPreviousPage_Z4395D14A(state.Table), (_arg4) => {
        dispatch(new Msg(1, new PaginateChange(0)));
    }), pageControl("\u003c", !Table_hasPreviousPage_Z4395D14A(state.Table), (_arg5) => {
        dispatch(new Msg(1, new PaginateChange(1)));
    }), pageControl("\u003e", !Table_hasNextPage_Z4395D14A(state.Table), (_arg6) => {
        dispatch(new Msg(1, new PaginateChange(2)));
    }), pageControl("\u003e\u003e", !Table_hasNextPage_Z4395D14A(state.Table), (_arg7) => {
        dispatch(new Msg(1, new PaginateChange(3)));
    }), (children_8 = ofArray(["Page ", Table_getState_Z4395D14A(state.Table).pagination.pageIndex + 1, " of ", Table_getPageCount_Z4395D14A(state.Table), " | Go to page:"]), createElement("p", {
        children: Interop_reactApi.Children.toArray(Array.from(children_8)),
    })), createElement("input", createObj(ofArray([["className", join(" ", ["input"])], ["type", "number"], (properties_9 = singleton_1(["width", 4 + "rem"]), ["style", createObj(properties_9)]), ["defaultValue", Table_getState_Z4395D14A(state.Table).pagination.pageIndex + 1], ["onChange", (ev) => {
        const value_50 = ev.target.valueAsNumber;
        if ((!(value_50 == null)) && (!Number.isNaN(value_50))) {
            dispatch(new Msg(1, new PaginateChange(4, round(value_50))));
        }
    }]]))), createElement("div", createObj(ofArray([["className", join(" ", ["select"])], (elems_7 = [createElement("select", createObj(ofArray([["onChange", (event) => {
        FSharpMap__get_Item(selectOptions, event.target.value)[1]();
    }], ["value", `${Table_getState_Z4395D14A(state.Table).pagination.pageSize}`], (elems_6 = toList(delay(() => map((option) => createElement("option", {
        key: option[0],
        value: option[0],
        children: option[1][0],
    }), selectOptions))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])])));
    return createElement("div", createObj(ofArray([["className", join(" ", ["p-2"])], (elems_10 = [createElement("table", {
        children: Interop_reactApi.Children.toArray([thead, tbody]),
    }), paginationControls], ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])])));
}

export function Component() {
    const patternInput = useFeliz_React__React_useElmish_Static_B42E862(init, update);
    return view(patternInput[0], patternInput[1]);
}

//# sourceMappingURL=Grouping.fs.js.map
